// extracted by mini-css-extract-plugin
module.exports = {"sidenav":"SideList_sidenav__j1iTt"};